import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SharedModule } from '../../shared.module';
import { FloatingProgressComponent } from './floating-progress.component';

@NgModule({
  declarations: [FloatingProgressComponent],
  imports: [SharedModule, MatProgressBarModule, MatIconModule],
  exports: [FloatingProgressComponent],
})
export class FloatingProgressModule {}
